import { ConfirmationDialog } from "../../../assets/types/common";
import { Constants } from "../../../assets/utils/lib/constants";
import { DropdownOption } from "../../../assets/vfx/controls/components/dropdown/controlDropdown";
import Drawer from "../../../assets/vfx/drawer/drawer";
import { LoadingIndicator } from "../../../assets/vfx/loadingIndicator/vfxLoadingIndicator";
import DisplayData from "../../common/DisplayData/DisplayData";
import { ViewProps } from "../props";

interface LookupGroupViewProps<T> {
    data: T | undefined;
    show: boolean;
    lookupCategoryLookupValues?: DropdownOption[] | undefined;
    onHide: () => void;
    onEdit: () => void;
    onDelete: () => void;
    isLoading: boolean;
}

export const LookupGroupView = <T extends ViewProps.GroupTypeDto,>(props: LookupGroupViewProps<T>) => {
    return (
        <Drawer.View
            className="w-30"
            show={props.show}
            backdrop={true}
            placement="end"
            scroll={true}
            onHide={() => props.onHide()}
            onEdit={props.isLoading ? undefined : props.onEdit}
            title="View Lookup Group"
            onDelete={(props.isLoading || props.onDelete === undefined) ? undefined : props.onDelete}
            modalDialogProps={props.onDelete === undefined ? undefined : new ConfirmationDialog().get(props.onDelete, "Delete", { "Name": props?.data?.name ?? Constants.emptyString })}
        >
            {props.isLoading ? (
                <LoadingIndicator isFullPage={true} />
            ) : (
                <>
                    <DisplayData text="Name" importedData={props.data?.name ?? Constants.emptyString} />
                    <DisplayData text="Description" importedData={props.data?.description ?? Constants.emptyString} />
                    {(() => {
                        if (props.data?.categoryId != undefined && props.data?.categoryId != null && props.data?.categoryId != Constants.emptyGuid) {
                            const category: DropdownOption | undefined = props.lookupCategoryLookupValues?.find(x => x.value === props.data?.categoryId);
                            if (category) {
                                return <DisplayData text="Category" importedData={category.display} />
                            }
                        }
                    })()}
                </>
            )}
        </Drawer.View>
    );
}